export default "https://cdn.questicon.mathletics.com/assets/images/Fluency-R-9d0be9640041bf28a4b5fcb18a660aa9.png";